export default "__VITE_ASSET__7a7a37a4__"